<div class="body" style="min-height: 100%">
  @if (submitted) {
    <div class="text-white-50"><H2>{{loadingStatus}}</H2></div>
  }
  @if (!submitted) {
    <div class="form">
      <h2>Messages are sent directly to me using the form below. </h2>
      <form [formGroup]="contactForm">
        <div class="form-row">
          <div class="form-group">
            <label for="name">Name</label>
            <input type="text" class="form-control" id="name" placeholder="Sample McPerson" formControlName="name">
            @if (contactForm.controls['name'].invalid && contactForm.controls['name'].dirty) {
              <div class="alert alert-danger">Name Must Be Between 1 and 30 Characters. Name Must Not Start or End with Spaces</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label for="email">Email</label>
            <input type="text" class="form-control" id="email" placeholder="sample@email.com" formControlName="email">
            @if (contactForm.controls['email'].invalid && contactForm.controls['email'].dirty) {
              <div class="alert alert-danger">Email Not Valid</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group">
            <label for="message">Message <br>(255 Character Max)</label>
            <input type="text" class="form-control" id="message" placeholder="Hello!" formControlName="msg">
            @if (contactForm.controls['msg'].invalid && contactForm.controls['msg'].dirty) {
              <div class="alert alert-danger">Message Must Be Between 1 and 255 Characters</div>
            }
          </div>
        </div>
        <div>
          <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="contactForm.invalid">Send</button>
        </div>
        <br/><br/><br/><br/>
      </form>
    </div>
  }
</div>
